import { render, staticRenderFns } from "./CertificationPanel.vue?vue&type=template&id=a7a22ac2&scoped=true"
import script from "./CertificationPanel.vue?vue&type=script&lang=js"
export * from "./CertificationPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a22ac2",
  null
  
)

export default component.exports